import React, { useRef } from "react";
import { Card, Typography, Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const UploadDocumentsCard = ({
  onUpload,
  activeCategory,
  disabled = false,
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (disabled) return;
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    if (disabled) return;
    const files = Array.from(e.target.files);

    // Convert files to your doc structure
    const uploadedDocs = files.map((file, index) => ({
      id: Date.now() + index,
      name: file.name,
      size: `${(file.size / 1024 / 1024).toFixed(1)} MB`,
      date: new Date().toISOString().split("T")[0],
      category: activeCategory === "all" ? "Uncategorized" : activeCategory,
      status: "Uploaded",
    }));

    onUpload(uploadedDocs);
    e.target.value = "";
  };

  return (
    <Card
      sx={{
        p: 2,
        border: "1px solid #E6E6E6",
        backgroundColor: "#fff",
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Typography className="sub-header" fontWeight={600} mb={2}>
        Upload Documents
      </Typography>
      <Card
        elevation={0}
        sx={{
          background: "#FFFFFF 0% 0% no-repeat padding-box",
          border: "1px dashed #E6E6E6",
          borderRadius: "4px",
          opacity: 1,
          textAlign: "center",
          p: 4,
          boxShadow: "none",
        }}
      >
        <img src="/icons/drop.svg" alt="drop files" width="20" height="20" />
        <Typography className="drop-file">
          Drop files here or click to upload
        </Typography>
        <Typography className="sub-drop-file" mt={1}>
          Support for PDF, DOC, XLS, and more
        </Typography>

        <Button
          variant="contained"
          sx={{
            mt: 2,
            backgroundColor: "#1F61C5",
            color: "#fff",
            textTransform: "none !important",
          }}
          onClick={handleClick}
          disabled={disabled}
        >
          Choose Files
        </Button>

        <input
          type="file"
          multiple
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
          disabled={disabled}
        />
      </Card>
    </Card>
  );
};

export default UploadDocumentsCard;
